import { environment } from '../../../environments/environment';
import { Utility } from '../utility';

export const emojiJiDaBai = {
    label: '鸡大白',
    height: 90,
    width: 90,
    path:"/upload/facetime/jidabai/",
    range:[[20210301,20210324]]
    // items: [
    //     {
    //         'not': 20210301,
    //         'id': 20210301,
    //         'image': '/upload/facetime/jidabai/20210301.gif',
    //         'title': '安慰',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210301)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210302,
    //         'id': 20210302,
    //         'image': '/upload/facetime/jidabai/20210302.gif',
    //         'title': '抱紧',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210302)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210303,
    //         'id': 20210303,
    //         'image': '/upload/facetime/jidabai/20210303.gif',
    //         'title': '变身',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210303)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210304,
    //         'id': 20210304,
    //         'image': '/upload/facetime/jidabai/20210304.gif',
    //         'title': '戳戳',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210304)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210305,
    //         'id': 20210305,
    //         'image': '/upload/facetime/jidabai/20210305.gif',
    //         'title': '打你',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210305)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210306,
    //         'id': 20210306,
    //         'image': '/upload/facetime/jidabai/20210306.gif',
    //         'title': '等饭',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210306)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210307,
    //         'id': 20210307,
    //         'image': '/upload/facetime/jidabai/20210307.gif',
    //         'title': '调皮',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210307)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210308,
    //         'id': 20210308,
    //         'image': '/upload/facetime/jidabai/20210308.gif',
    //         'title': '发芽',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210308)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210309,
    //         'id': 20210309,
    //         'image': '/upload/facetime/jidabai/20210309.gif',
    //         'title': '鼓掌',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210309)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210310,
    //         'id': 20210310,
    //         'image': '/upload/facetime/jidabai/20210310.gif',
    //         'title': '观望',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210310)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210311,
    //         'id': 20210311,
    //         'image': '/upload/facetime/jidabai/20210311.gif',
    //         'title': '欢呼',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210311)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210312,
    //         'id': 20210312,
    //         'image': '/upload/facetime/jidabai/20210312.gif',
    //         'title': '击拳',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210312)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210313,
    //         'id': 20210313,
    //         'image': '/upload/facetime/jidabai/20210313.gif',
    //         'title': '击掌',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210313)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210314,
    //         'id': 20210314,
    //         'image': '/upload/facetime/jidabai/20210314.gif',
    //         'title': '叽喳',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210314)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210315,
    //         'id': 20210315,
    //         'image': '/upload/facetime/jidabai/20210315.gif',
    //         'title': '溜了',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210315)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210316,
    //         'id': 20210316,
    //         'image': '/upload/facetime/jidabai/20210316.gif',
    //         'title': '捏脸',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210316)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210317,
    //         'id': 20210317,
    //         'image': '/upload/facetime/jidabai/20210317.gif',
    //         'title': '清醒点',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210317)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210318,
    //         'id': 20210318,
    //         'image': '/upload/facetime/jidabai/20210318.gif',
    //         'title': '刷牙',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210318)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210319,
    //         'id': 20210319,
    //         'image': '/upload/facetime/jidabai/20210319.gif',
    //         'title': '提示',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210319)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210320,
    //         'id': 20210320,
    //         'image': '/upload/facetime/jidabai/20210320.gif',
    //         'title': '跳舞',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210320)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210321,
    //         'id': 20210321,
    //         'image': '/upload/facetime/jidabai/20210321.gif',
    //         'title': '吐',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210321)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210322,
    //         'id': 20210322,
    //         'image': '/upload/facetime/jidabai/20210322.gif',
    //         'title': '依靠',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210322)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210323,
    //         'id': 20210323,
    //         'image': '/upload/facetime/jidabai/20210323.gif',
    //         'title': '赞',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210323)',
            
    //         'GroupID': 202103
    //     },
    //     {
    //         'not': 20210324,
    //         'id': 20210324,
    //         'image': '/upload/facetime/jidabai/20210324.gif',
    //         'title': '知错',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210324)',
            
    //         'GroupID': 202103
    //     },
    // ]
}
